export default __webpack_public_path__ + "static/media/location.7d8dd40f.svg";